import React from 'react';
import CriticalError from './CriticalError';

export class ErrorBoundary extends React.Component<React.PropsWithChildren> {
  state: { hasError: boolean };

  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <CriticalError />;
    }

    return this.props.children;
  }
}
